/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useAddToAny } from '@/features/shared/Hooks';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React from 'react';
import { FacebookIcon } from '../Icons/social/Facebook';
import { LinkedinIcon } from '../Icons/social/LinkedinIcon';
import { XIcon } from '../Icons/social/XIcon';
import { MuiTypography } from '../material-ui';
import useStyles from './SocialShare.style';

export interface SocialShareProps {
  theme?: Theme;
  shareText?: string;
  title?: string;
}

const SocialShare = ({ theme = Theme.light, shareText = '', title = '' }: SocialShareProps) => {
  const classes = useStyles({});

  useAddToAny();

  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <div className={rootClassName} data-datalayer-position="social_share">
      <MuiTypography variant="subtitle2" className={classes.label}>
        {shareText}
      </MuiTypography>
      <div
        className={clsx('a2a_kit a2a_kit_size_32', 'a2a_default_style')}
        data-a2a-title={title}
        data-a2a-url={window.location.href}
        data-a2a-icon-color="transparent,currentColor"
      >
        <a className="a2a_button_facebook social-icon">
          <FacebookIcon width="36px" />
        </a>
        <a className="a2a_button_x social-icon">
          <XIcon />
        </a>
        <a className="a2a_button_linkedin social-icon">
          <LinkedinIcon />
        </a>
        <a className="a2a_dd social-icon plus-icon" />
      </div>
    </div>
  );
};

export default SocialShare;
